import { PropsWithChildren } from "react";
import styles from "./style.module.css";
import { cn } from "@/core/helpers/cn";
import scratchesImg from "@/domains/estate/components/elevator/res/elevator-standard-scratches@2x.png";

export function ElevatorStandardFrame({
  size,
  children,
}: PropsWithChildren<{ size: "sm" | "lg" }>) {
  return (
    <div className={cn(styles.container, styles[size])}>
      <div className={styles.scratches} style={{ backgroundImage: `url(${scratchesImg})` }} />
      <div className={styles.inner} />

      <div className="relative z-1">{children}</div>
    </div>
  );
}
